import pl from "@locales/patient/shared_tab/pl.json";
import en from "@locales/patient/shared_tab/en.json";

export default {
  pl: pl,
  en: en,
};
